var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTipsPerLocationImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 64,
    viewBox: "0 0 68 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.9738 45.244C62.0765 42.013 28.0329 4.86837 22.5961 6.02652C18.4621 6.90132 4.40974 55.3744 7.41878 57.692C10.4278 60.0097 59.8308 48.5933 60.9738 45.244ZM31.975 39.053C29.234 33.1114 27.141 26.8976 25.7316 20.5171C24.8973 16.9134 28.2721 16.0757 29.3469 19.9037C31.0155 25.8182 32.4908 32.6144 34.1622 38.5963C34.5794 40.0543 32.5631 40.3267 31.975 39.053ZM36.2758 45.7364C34.5891 48.2659 31.0837 45.2137 33.2528 43.4944C34.8811 42.1258 37.676 43.6306 36.2716 45.7364H36.2758Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTipsPerLocationImage);
export default __webpack_public_path__ + "static/media/TipsPerLocationImage.ef9001ad04f8b302eadbd7b705665441.svg";
export { ForwardRef as ReactComponent };